import GSAP from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
GSAP.registerPlugin(ScrollTrigger);

const DESKTOP_MEDIA_QUERY = "(min-width: 1024px)";
const STICKY_TOP = 0;
const SCROLL_PER_ROW = 200;

export default class Studio {
  constructor() {
    this.mm = GSAP.matchMedia();
  }

  initStackingSticky() {
    this.destroy();

    const wrapper = document.querySelector(
      ".how__it__works__section .row__item__wrapper",
    );
    if (!wrapper) return;

    const rows = Array.from(wrapper.querySelectorAll(".wrapper__single__row"));
    if (rows.length < 2) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    this.mm.add(DESKTOP_MEDIA_QUERY, () => {
      const animatedRows = rows.slice(1);
      const totalScrollDistance = animatedRows.length * SCROLL_PER_ROW;

      const timeline = GSAP.timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: `top ${STICKY_TOP}px`,
          end: `+=${totalScrollDistance}`,
          scrub: true,
          pin: true,
          invalidateOnRefresh: true,
        },
      });

      animatedRows.forEach((row) => {
        timeline.to(row, { marginTop: "0%", ease: "none", duration: 1 });
      });

      return () => {
        timeline.scrollTrigger?.kill();
        timeline.kill();
        GSAP.set(rows, { clearProps: "marginTop" });
      };
    });
  }

  destroy() {
    this.mm.revert();
  }
}